const blockBody = () => {

    const body = document.body;
    const blockingClass = 'ov-hidden';

    return {
        block() {
            body.classList.add(blockingClass);
        },
        unblock() {
            body.classList.remove(blockingClass);
        }
    };
};

export default blockBody;
